import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import faceValuePopupServices from '@src/services/faceValuePopup.services';

export const getFaceValues = createAsyncThunk(
    'getFaceValues',
    async (body,{ getState, rejectWithValue }) => {
        const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      try {
        return await faceValuePopupServices.getFaceValues({
          customerId: customerId,
        });
      } catch (error) {
        return rejectWithValue(error?.data);
      }
    },
  );

  export const faceValuesSave = createAsyncThunk(
    'faceValuesSave',
    async (body, { getState, rejectWithValue }) => {
      try {
        const customerId = await getState()?.customer?.selectedCustomer?.customerId;
        if (!customerId) {
          return rejectWithValue({
            message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
          });
        }
        const res = await faceValuePopupServices.faceValuesSave({ entity: { ...body, faceValueCustomerId:customerId } });
        return res;
      } catch (error) {
        return rejectWithValue(error?.data);
      }
    },
  );

  const initialState = {
    faceValues: {},
  };

  export const faceValuePopupSlice = createSlice({
    name: 'faceValuePopup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getFaceValues.fulfilled, (state, action) => {
        state.faceValues = { ...action.payload.data };

      });
    },
  });

  export const {updateIsAccepted , updateIsClosed, updateIsMainPageAccepted ,updateIsMainPageClosed } = faceValuePopupSlice.actions;


